module.exports = __webpack_public_path__ + "img/slideFour.ba6f851d.svg";